export type Browser = "chrome" | "firefox" | "safari" | "edge" | "unknown";

/**
 * UA-string-based browser detection. Order matters: Edge's UA contains
 * "Chrome" (Chromium-based), Brave/Arc/Opera also report as Chrome —
 * we match those as "chrome" since their devtools UI is identical.
 *
 * Detection is for instruction-rendering only; no security control gates
 * on the result.
 */
export function detectBrowser(userAgent?: string): Browser {
    const ua = userAgent ?? (typeof navigator !== "undefined" ? navigator.userAgent : "");
    if (ua.includes("Edg/")) return "edge";
    if (ua.includes("Firefox/")) return "firefox";
    if (ua.includes("Chrome/")) return "chrome";
    if (ua.includes("Safari/")) return "safari";
    return "unknown";
}
